import { SVG, SVGProps } from './svg'

export function IconToolEllipse(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 32 32">
      <path
        fillRule="evenodd"
        d="M17.97 8.65c4.79.74 8.53 4.12 8.53 8.35 0 4.8-4.81 8.5-10.5 8.5S5.5 21.8 5.5 17c0-4.23 3.74-7.61 8.53-8.35a2 2 0 013.94 0zM16 11a2 2 0 001.9-1.35c4.4.7 7.6 3.8 7.6 7.35 0 4.04-4.14 7.5-9.5 7.5S6.5 21.04 6.5 17c0-3.55 3.2-6.65 7.6-7.35A2 2 0 0016 11zm1-2a1 1 0 11-2 0 1 1 0 012 0z"
      />
    </SVG>
  )
}
